import DOMPurify from 'dompurify';

const RICH_TEXT_OPTIONS = {
  ALLOWED_TAGS: [
    'b',
    'strong',
    'i',
    'em',
    'u',
    'p',
    'br',
    'ul',
    'ol',
    'li',
    'a',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};

export const getRewardDescription = (reward, fallback = '') =>
  String(reward?.description || reward?.subtitle || fallback || '');

export const getRewardDescriptionHtml = (reward, fallback = '') =>
  DOMPurify.sanitize(
    getRewardDescription(reward, fallback).replace(/\r\n|\r|\n/g, '<br />'),
    RICH_TEXT_OPTIONS
  );

export const getRewardDescriptionText = (reward, fallback = '') => {
  const descriptionWithSpacing = getRewardDescription(reward, fallback).replace(
    /<br\s*\/?>|<\/(?:p|li|div|h[1-6])>/gi,
    ' '
  );
  const sanitizedText = DOMPurify.sanitize(
    descriptionWithSpacing,
    { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }
  );
  const textArea = document.createElement('textarea');
  textArea.innerHTML = sanitizedText;

  return textArea.value.replace(/\s+/g, ' ').trim();
};
